import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';
import { spaces } from '../../assets/styles/themes/tokens';

const ChangeEmailLoading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid='change-email-loading'
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: spaces.xl,
      }}
    >
      <Box 
        sx={{ 
          display: 'flex',
          justifyContent: 'center',
        }}>
        <CircularProgress
          size='40px'
          sx={{
            '& .MuiCircularProgress-svg': {
              height: 'auto',
              width: 'auto',
            }
          }}
        />
      </Box>  
      <Typography variant='body1' align='center' gutterBottom>
        {t('Please be patient')} — {t('Your email is being changed')}.
      </Typography>
    </Box>
  );
};

export default ChangeEmailLoading;
